var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 22,
  viewBox: "0 0 24 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#007C76",
  fillRule: "nonzero",
  d: "M3 9H0l12-9 12 9h-3v13h-7v-6h-4v6H3z"
})));
export default SvgHomeIcon;